module.exports = __webpack_public_path__ + "img/score_right.674be4e0.png";